import { getExpoPushTokenAsync } from "expo-notifications";
import Constants from "expo-constants";

export const getPushToken = async () => {
  const projectId = Constants.expoConfig?.extra?.eas?.projectId ?? Constants.easConfig?.projectId;

  return (
    await getExpoPushTokenAsync({
      projectId,
    })
  ).data;
};
